<template>
    <v-col cols="12" md="3">
    <v-card class="ma-2">
        <v-card-title class="title font-weight-black">
            <v-icon class="pr-3">home</v-icon> Hotels
        </v-card-title>

        <v-card-text>
            <v-container>
                <v-layout row wrap>
                    <v-col cols="12"><ies-hotel-picker></ies-hotel-picker></v-col>
                    <v-col cols="12"><v-btn block href="hotels/list">List All Hotels</v-btn></v-col>
                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
    </v-col>
</template>

<script>
    /**
     * Display buttons linking through to hotels' pages
     */
    export default {
        props:[],

        data: function() {
            return {}
        },
    }
</script>
